import { gql } from '@soundxyz/gql-string';
import { CreateFeedPostDocument, useMutation } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  mutation CreateFeedPost($input: CreateReleasePostInput!) {
    createReleasePost(input: $input) {
      __typename
      ... on MutationCreateReleasePostSuccess {
        data {
          id
        }
      }

      ... on ValidationError {
        __typename
        message
      }
    }
  }
`);

export function useFeedPost() {
  const { isLoading, mutateAsync } = useMutation(CreateFeedPostDocument, {});

  return {
    isLoading,
    mutateAsync,
  };
}
